import styled from 'styled-components';
import { H4Bold } from '@comeon/ui';
import { SidebarHeader } from '~/components/sidebar/index.js';

const CustomSidebarHeader = styled(SidebarHeader)`
	background-color: var(--marketplace-nav-header, transparent);
`;

const MarketplaceNavHeader = ({ title, goBack }) => (
	<CustomSidebarHeader leftSideIcon="BACK_ICON" onLeftSideButtonClick={goBack}>
		<H4Bold className="page-head__title">{title}</H4Bold>
		<div className="page-head__right-side" />
	</CustomSidebarHeader>
);

export default MarketplaceNavHeader;
